import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Form, Input } from 'reactstrap'

import ScrollArea from '../../../partials/ScrollArea'

import style from './style'

import PermissionList from '../../../../permissions.json'

export const GroupForm = props => {
  return (
    <Form>
      <Row className={css(style.form.group)}>
        <Col>
          <Row>
            <Col>
              <h4 className={css(style.headers.h4)}>Settings</h4>
            </Col>
          </Row>
          <Row>
            <Col xs='auto' />
            <Col xs='2' className={`d-flex align-items-center`}>
              <span>name</span>
            </Col>
            <Col>
              <Input
                value={props.editor.name}
                onChange={props.onNameInputChange}
                onBlur={props.onNameInputBlur}
                className={css(
                  style.form.input,
                  style[props.theme.name]
                    ? style[props.theme.name].form.input
                    : null
                )}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        className={css(
          style.form.group,
          style[props.theme.name] ? style[props.theme.name].form.group : null
        )}
      >
        <Col>
          <Row>
            <Col>
              <h4 className={css(style.headers.h4)}>Permissions</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <ScrollArea
                style={{
                  height: `300px`
                }}
              >
                <Col
                  className={css(
                    style.list.list,
                    style[props.theme.name]
                      ? style[props.theme.name].list.list
                      : null
                  )}
                >
                  <Row
                    className={css(
                      style.list.header,
                      style[props.theme.name]
                        ? style[props.theme.name].list.header
                        : null
                    )}
                  />
                  {PermissionList.permissions.global
                    .filter(perm => perm.display)
                    .map((perm, index) => (
                      <Row
                        data-name={perm.name}
                        onClick={props.onPermClick}
                        key={`${perm.name}_${index}`}
                        className={css(
                          style.list.row,
                          style[props.theme.name]
                            ? style[props.theme.name].list.row
                            : null
                          // style.list.rowActive
                        )}
                      >
                        <Col
                          xs='auto'
                          className={`d-flex align-items-center justify-content-center`}
                        >
                          <span
                            className={css(
                              style.form.checkbox,
                              style[props.theme.name]
                                ? style[props.theme.name].form.checkbox
                                : null,
                              props.group.permissions[perm.name]
                                ? style[props.theme.name]
                                  ? (style.form.checkbox_check,
                                    style[props.theme.name].form.checkbox_check)
                                  : style.form.checkbox_check
                                : null
                            )}
                          />
                        </Col>
                        <Col
                          className={`d-flex align-items-center justify-content-center`}
                        >
                          {perm.name}
                        </Col>
                        <Col className={`d-none d-lg-block`}>
                          <p className={css(style.list.p)}>{perm.desc}</p>
                        </Col>
                      </Row>
                    ))}
                </Col>
              </ScrollArea>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  )
}

export default GroupForm



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupForm/index.js